import {useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {useGetAutoDeliveryDetailsDcxLazyQuery, useGetAutoDeliveryDetailsExtendedDcxLazyQuery} from '@/api/consumerApi';
import type {PendingReturnActionId} from '@/consts/pendingReturnActionIds';
import {PENDING_RETURN_ACTION_IDS} from '@/consts/pendingReturnActionIds';
import {selectPendingReturnActionId} from '@/state/selectors/global';
import {clearPendingReturnActionId} from '@/state/slices/globalSlice';

import useOnReturnToTab from './useOnReturnToTab';

const useOnReturnActionManager = (): void => {
    const dispatch = useDispatch();
    const pendingReturnActionId = useSelector(selectPendingReturnActionId) as PendingReturnActionId | null;
    const [refetchAutoDeliveryDcxDetails] = useGetAutoDeliveryDetailsDcxLazyQuery();
    const [refetchAutoDeliveryDcxDetailsExtended] = useGetAutoDeliveryDetailsExtendedDcxLazyQuery();
    const isHandlingRef = useRef<boolean>(false);

    const checkAndRunAction = async (): Promise<void> => {
        if (!pendingReturnActionId || isHandlingRef.current) return;

        isHandlingRef.current = true;

        try {
            if (pendingReturnActionId === PENDING_RETURN_ACTION_IDS.AUTO_DELIVERY_DETAILS_EXTENDED) {
                await refetchAutoDeliveryDcxDetailsExtended().unwrap();
            } else if (pendingReturnActionId === PENDING_RETURN_ACTION_IDS.AUTO_DELIVERY_DETAILS) {
                await refetchAutoDeliveryDcxDetails().unwrap();
            }
        } finally {
            dispatch(clearPendingReturnActionId());
            isHandlingRef.current = false;
        }
    };

    useOnReturnToTab(checkAndRunAction);
};

export default useOnReturnActionManager;
